<!--  -->
<template>
    <div class="outer-container">
      <div class="add-container">
        <div class="increase" @click="addUser">
          <img src="../assets/xinzeng.png" alt="add" > 
          新增
        </div>
      </div>
      <div class="contact-list-wrapper">
        <div class="contact-item" v-for="(user,index) in addUserList" :key="index" @click="editUser(user)">
          <div class="perItem">
            <div class="left">
              <div class="title">{{user.name}}</div>
              <div class="cell">
                <span class="info-title">手机号码 </span>
                <span class="info-content">{{ user.phoneExt }}</span>
              </div>
            </div>
            <div class="right">
              <img src="../assets/jiantouyou.png" alt="edit">
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
// import引入的组件需要注入到对象中才能使用
  components: {},
  data  () {
// 这里存放数据
    return {
        addUserList:[]
    }
  },
// 监听属性 类似于data概念
  computed: {},
// 监控data中的数据变化
  watch: {},
// 方法集合
  methods: {
    editUser(user){
      this.$router.push({
        name: "userAdd",
        params: {
          editUser: user,
          path: this.$route.name,
        },
      })
    },
    addUser(){
      this.$router.push({
        name: "userAdd",
        params: {
          editUser: false,
          path: this.$route.name,
        },
      })
    },
    async getUserData() {
      try {
        const data = await this.$http.get('/tempt/api/sjte/getUers'); // 通过this.$http调用全局挂载的axios实例发送GET请求，这里的/api/some-endpoint根据实际后端接口调整
        this.addUserList = data.result
      } catch (error) {
        console.log("error111")
      } finally {
        console.log("error22222")
      }
    },
  },
// 生命周期 - 创建完成（可以访问当前this实例）
  created  () {
        this.getUserData()
  },
// 生命周期 - 挂载完成（可以访问DOM元素）
  mounted  () {

  },
  beforeCreate  () {}, // 生命周期 - 创建之前
  beforeMount  () {}, // 生命周期 - 挂载之前
  beforeUpdate  () {}, // 生命周期 - 更新之前
  updated  () {}, // 生命周期 - 更新之后
  beforeDestroy  () {}, // 生命周期 - 销毁之前
  destroyed  () {}, // 生命周期 - 销毁完成
  activated  () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
.add-container {
    height: 80px;
    background: #f3f4f5;
}
.add-container, .increase {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
}
.increase {
    height: 48px;
    background: #fff;
    border-radius: 8px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #007aaa;
    margin: 16px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.increase>img {
    width: 15px;
    height: 15px;
    margin-right: 9px;
}
.perItem {
    margin: 16px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, .1);
}
.title {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #000;
    font-weight: 400;
}
.cell, .right {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
.info-title {
    font-size: 12px;
    color: rgba(0, 0, 0, .4);
    font-weight: 400;
    margin-right: 8px;
}
.info-content {
    font-size: 12px;
    color: rgba(0, 0, 0, .8);
    font-weight: 400;
}
.right {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.perItem .right img {
    width: 7px;
    height: 11px;
    margin-left: 5px;
}
</style>